import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#fcfaf6",
  foreground: "#25221f",
  surface: "#ffffff",
  surfaceForeground: "#25221f",
  surfaceSecondary: "#f5f3ef",
  surfaceSecondaryForeground: "#25221f",
  surfaceTertiary: "#ece9e4",
  surfaceTertiaryForeground: "#25221f",
  overlay: "#ffffff",
  overlayForeground: "#25221f",
  muted: "#6d6861",
  default: "#f2f0ec",
  defaultForeground: "#25221f",
  accent: "#007b95",
  accentForeground: "#f5feff",
  danger: "#c84341",
  dangerForeground: "#ffffff",
  warning: "#dea645",
  warningForeground: "#362512",
  success: "#008853",
  successForeground: "#ffffff",
  separator: "#8a857e",
  glassBackground: "rgba(255, 255, 255, 0.85)",
  glassBorder: "rgba(37, 34, 31, 0.12)",
  glassHighlight: "rgba(37, 34, 31, 0.08)",
  glow0: "rgba(0, 123, 149, 0.11)",
  glow1: "rgba(0, 136, 83, 0.09)",
  glow2: "rgba(200, 170, 110, 0.08)",
  mutedForeground: "#6d6861",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(40, 36, 30, 0.08)",
  overlayShadow: "rgba(20, 60, 75, 0.14)",
  fieldShadow: "rgba(40, 36, 30, 0.06)",
  fieldBorder: "rgba(40, 36, 30, 0.15)",
  fieldPlaceholder: "rgba(40, 36, 30, 0.55)",
  fieldBackground: "rgba(40, 36, 30, 0.04)",
  segment: "#ffffff",
  segmentForeground: "#25221f",
  link: "#007b95",
  focus: "#007b95",
  fieldForeground: "#25221f",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#a29e96",
  primary: "#007b95",
  primaryForeground: "#f5feff",
  secondary: "#f2f0ec",
  secondaryForeground: "#25221f",
  backdrop: "rgba(20, 24, 30, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#191714",
  foreground: "#fbfaf7",
  surface: "#22201d",
  surfaceForeground: "#fbfaf7",
  surfaceSecondary: "#2c2a26",
  surfaceSecondaryForeground: "#fbfaf7",
  surfaceTertiary: "#383530",
  surfaceTertiaryForeground: "#fbfaf7",
  overlay: "#2c2a26",
  overlayForeground: "#fbfaf7",
  muted: "#a8a49c",
  default: "#35322e",
  defaultForeground: "#fbfaf7",
  accent: "#2db8cc",
  accentForeground: "#091619",
  danger: "#e8605b",
  dangerForeground: "#ffffff",
  warning: "#e9b860",
  warningForeground: "#2b1c08",
  success: "#45bf82",
  successForeground: "#091a11",
  separator: "#55524d",
  glassBackground: "rgba(34, 32, 29, 0.55)",
  glassBorder: "rgba(255, 255, 255, 0.12)",
  glassHighlight: "rgba(255, 255, 255, 0.22)",
  glow0: "rgba(45, 184, 204, 0.4)",
  glow1: "rgba(69, 191, 130, 0.34)",
  glow2: "rgba(210, 175, 110, 0.24)",
  mutedForeground: "#a8a49c",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.3)",
  overlayShadow: "rgba(0, 0, 0, 0.5)",
  fieldShadow: "rgba(0, 0, 0, 0.25)",
  fieldBorder: "rgba(255, 255, 255, 0.12)",
  fieldPlaceholder: "rgba(255, 255, 255, 0.45)",
  fieldBackground: "rgba(255, 255, 255, 0.04)",
  segment: "#4a4742",
  segmentForeground: "#fbfaf7",
  link: "#2db8cc",
  focus: "#2db8cc",
  fieldForeground: "#fbfaf7",
  radius: "0.65rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#504d48",
  primary: "#2db8cc",
  primaryForeground: "#091619",
  secondary: "#35322e",
  secondaryForeground: "#fbfaf7",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
